import { render, staticRenderFns } from "./ScreeningBehaviorsSequence.vue?vue&type=template&id=7069c530&scoped=true&"
import script from "./ScreeningBehaviorsSequence.vue?vue&type=script&lang=js&"
export * from "./ScreeningBehaviorsSequence.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningBehaviorsSequence.vue?vue&type=style&index=0&id=7069c530&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7069c530",
  null
  
)

export default component.exports